import IdCardForm from './IdCardForm'

export default IdCardForm
